import { PixelBuffer } from "../pixel/PixelBuffer";
import type { Selection } from "../selection/Selection";
import type { Filter } from "./Filter";

export interface SolarizeParams {
  threshold: number;
}

function clamp8(v: number): number {
  return v < 0 ? 0 : v > 255 ? 255 : v;
}

export const Solarize: Filter<SolarizeParams> = {
  id: "solarize",
  displayName: "Solarize",
  defaultParams: { threshold: 128 },

  apply(input: PixelBuffer, params: SolarizeParams, _selection: Selection | null): PixelBuffer {
    const w = input.width;
    const h = input.height;
    const out = new PixelBuffer(w, h, input.mode);
    const src = input.data;
    const dst = out.data;

    if (w === 0 || h === 0) { dst.set(src); return out; }

    const threshold = params.threshold;

    for (let i = 0; i < w * h; i++) {
      const o = i * 4;
      for (let c = 0; c < 3; c++) {
        const v = src[o + c]!;
        dst[o + c] = v > threshold ? clamp8(255 - v) : v;
      }
      dst[o + 3] = src[o + 3]!;
    }
    return out;
  },
};
